import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";
import { isLessThanDay } from "../../../assets/jss/util/validateUtil";

export default function Themdonvi() {
  const [loaihinhvantai, setLoaihinhvantai] = React.useState([]);
  const [tendonvi, setTendonvi] = React.useState("");
  const [sonha, setSonha] = React.useState("");
  const [diachidonvi, setDiachidonvi] = React.useState("");
  const [sodienthoai, setSodienthoai] = React.useState("");
  const [giayphepdkkd, setGiayphepdkkd] = React.useState("");
  const [ngaycapgpdkkd, setNgaycapgpdkkd] = React.useState(dayjs());
  const [coquancap, setCoquancap] = React.useState("");
  const [nguoidaidien, setNguoidaidien] = React.useState("");
  const [sogiayphep, setSogiayphep] = React.useState("");
  const [vantaivalue, setVantaivalue] = React.useState([]);
  const [xa, setXa] = React.useState([]);
  const [xavalue, setXavalue] = React.useState(0);
  const [xaten, setXaten] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alert2, setAlert2] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const [ngaycapgpkdvt, setNgaycapgpkdvt] = React.useState(dayjs());
  const [ngayhethangpkdvt, setNgayhethangpkdvt] = React.useState(null);
  const [nguoidieuhanh, setNguoidieuhanh] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getloaihinhvantai = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/getdmloaihinhvantaiall?username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaihinhvantai(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getxaphuong = () => {
    var url = Config.backend + "/api/Donvi/getpxgialai?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setXa(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const insertdonvi = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var ngaygpkd =
        ngaycapgpdkkd.$y +
        "-" +
        String(ngaycapgpdkkd.$M + 1).padStart(2, "0") +
        "-" +
        ngaycapgpdkkd.$D;
      var ngaygpkdvt =
        ngaycapgpkdvt.$y +
        "-" +
        String(ngaycapgpkdvt.$M + 1).padStart(2, "0") +
        "-" +
        ngaycapgpkdvt.$D;
      var ngayhethan = "";
      if (ngayhethangpkdvt) {
        ngayhethan =
          ngayhethangpkdvt.$y +
          "-" +
          String(ngayhethangpkdvt.$M + 1).padStart(2, "0") +
          "-" +
          ngayhethangpkdvt.$D;
      }
      let loaihinhvantai = [];
      vantaivalue.map((row) => {
        loaihinhvantai.push({ id: row.id });
      });
      var url = Config.backend + "/api/Donvi/themdvvt";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          tendonvi: tendonvi,
          diachidonvi: diachidonvi,
          phuongxa_id: xavalue,
          sonha: sonha,
          sodienthoai: sodienthoai,
          giayphepdkkd: giayphepdkkd,
          ngaycapgpdkkd: ngaygpkd,
          coquancap: coquancap,
          nguoidaidien: nguoidaidien,
          sogiayphep: sogiayphep,
          ngaycapgpkdvt: ngaygpkdvt,
          ngayhethangpkdvt: ngayhethan,
          nguoidieuhanh: nguoidieuhanh,
          loaihinhvantai: loaihinhvantai,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else if (data === 2) {
            showNotification1();
          } else showNotification2();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const showNotification2 = () => {
    setAlert2(true);
    setTimeout(function () {
      setAlert2(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra ngay cap GPDKVT va ngay het han GPDKVT
    if (ngayhethangpkdvt) {
      if (isLessThanDay(ngayhethangpkdvt, ngaycapgpkdvt)) {
        return Error.ER0001;
      }
    }
    // Kiem tra cac truong bat buoc nhap
    if (tendonvi.trim() === "") {
      return Error.ER0002;
    }
    if (!xavalue || xavalue === 0) {
      return Error.ER0004;
    }
    if (vantaivalue.length == 0) {
      return Error.ER0005;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    getloaihinhvantai();
    getxaphuong();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Tên đơn vị"
                value={tendonvi}
                variant="outlined"
                size="small"
                onChange={(event) => {
                  setTendonvi(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số nhà, thôn, xóm"
                variant="outlined"
                value={sonha}
                size="small"
                onChange={(event) => {
                  setSonha(event.target.value);
                  if (event.target.value) {
                    setDiachidonvi(event.target.value + ", " + xaten);
                  }
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={xa}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setXavalue(value.id);
                  setXaten(value.ten);
                  setDiachidonvi(sonha + ", " + value.ten);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setXavalue(null);
                  } else {
                    setXavalue(xa.find(({ ten }) => ten === newInputValue).id);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn Phường/Xã"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                value={diachidonvi}
                size="small"
                disabled
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ marginTop: "1px" }}>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={sodienthoai}
                onChange={(event) => {
                  setSodienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số GPĐKKD"
                variant="outlined"
                size="small"
                value={giayphepdkkd}
                onChange={(event) => {
                  setGiayphepdkkd(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp GPĐKKD"
                  value={ngaycapgpdkkd}
                  onChange={(newValue) => {
                    setNgaycapgpdkkd(newValue);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "37px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Cơ quan cấp GPĐKKD"
                variant="outlined"
                size="small"
                value={coquancap}
                onChange={(event) => {
                  setCoquancap(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Người đại diện"
                variant="outlined"
                value={nguoidaidien}
                size="small"
                onChange={(event) => {
                  setNguoidaidien(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Số GPĐKVT"
                variant="outlined"
                value={sogiayphep}
                size="small"
                onChange={(event) => {
                  setSogiayphep(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp GPĐKVT"
                  value={ngaycapgpkdvt}
                  onChange={(newValue) => {
                    setNgaycapgpkdvt(newValue);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "37px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày hết hạn GPĐKVT (không thời hạn thì để trống)"
                  value={ngayhethangpkdvt}
                  onChange={(newValue) => {
                    setNgayhethangpkdvt(newValue);
                  }}
                  format="DD/MM/YYYY"
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "37px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <TextField
                label="Người điều hành"
                variant="outlined"
                value={nguoidieuhanh}
                size="small"
                onChange={(event) => {
                  setNguoidieuhanh(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ marginTop: "10px" }}>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                multiple
                freeSolo
                disableClearable
                size="small"
                options={loaihinhvantai}
                getOptionLabel={(option) => option.ten}
                onChange={(event, newValue) => {
                  setVantaivalue(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn loại hình vận tải"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        //height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={insertdonvi}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warrning"
            icon={AddAlert}
            message="Trùng Giấy phép ĐKKD, không thêm mới được"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert2}
            closeNotification={() => setAlert2(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
